import { useGetAuthContextQuery } from 'src/services/auth/auth.service';

import { TenantHierarchyLevel } from 'src/types/enums';

export const useOrgHierarchy = (): TenantHierarchyLevel => {
  const { currentData: authContext } = useGetAuthContextQuery();

  return authContext?.organization.hierarchy_level as TenantHierarchyLevel;
};
